/* Fashion CITY — 상품 사진 위 작업 위치 표 (기본값) + 자수 실 색상 + 옷 사이즈
   ★ 모자는 assets/fc-po-colors.js, 스웻셔츠는 assets/fc-po-sweatshirt.js 에서 따로 잡습니다.

     v     : 손님에게 보이는 이름
     x, y  : 사진에서 놓이는 자리. 사진 왼쪽 위가 0,0 / 오른쪽 아래가 100,100
     w     : Medium 크기일 때 폭 (사진 가로폭의 %)
     h     : (선택) Medium 일 때 글자 높이 — 넣으면 글자를 세로로 늘려서 채웁니다
     sizes : [Small, Medium, Large] 의 실제 인치

   ※ 옷의 소매(Sleeve) 자리는 전부 뺐습니다.
*/
window.FCPO_PLACE = {
  cap: [
    { v: 'Front panel', x: 50, y: 47, w: 34, sizes: [2, 3, 4] },
    { v: 'Left side',   x: 27, y: 52, w: 14, sizes: [1.5, 2, 2.5] },
    { v: 'Right side',  x: 73, y: 52, w: 14, sizes: [1.5, 2, 2.5] },
    { v: 'Back',        x: 50, y: 52, w: 18, sizes: [1.5, 2, 2.5] }
  ],
  apparel: [
    { v: 'Left chest',  x: 38, y: 36, w: 15, sizes: [3, 4, 5] },
    { v: 'Full front',  x: 50, y: 40, w: 40, sizes: [8, 10, 12] },
    { v: 'Full back',   x: 50, y: 42, w: 40, sizes: [10, 12, 14] }
  ],
  bag: [
    { v: 'Front', x: 50, y: 50, w: 44, sizes: [5, 8, 10] },
    { v: 'Back',  x: 50, y: 50, w: 44, sizes: [5, 8, 10] }
  ]
};

/* ── 옷 사이즈별 수량 ─────────────────────────────────────────
   손님이 사이즈마다 몇 장씩 주문할지 적는 칸입니다. 합계가 곧 수량이 됩니다.
   ★ 사이즈를 넣거나 빼려면 아래 목록만 고치세요.
     예) 큰 사이즈도 받으려면 → ['S', 'M', 'L', 'XL', '2XL', '3XL']
   모자·가방처럼 사이즈가 하나뿐인 제품은 여기 없으니 칸이 안 생깁니다.
*/
window.FCPO_SIZERUN = {
  apparel: ['S', 'M', 'L', 'XL']
};

/* 특정 상품만 사이즈를 다르게 하고 싶을 때 (핸들 = 상품 주소 맨 뒷부분) */
window.FCPO_SIZERUN_BY_HANDLE = {
  // 'custom-t-shirt-your-design': ['XS', 'S', 'M', 'L', 'XL', '2XL']
};

/* ── 자수 실 색상 ──────────────────────────────────────────────
   ★ 실 색을 넣거나 빼려면 여기만 고치면 됩니다.  ['이름', 'rgb(빨강,초록,파랑)']
   맨 위에 있는 색이 손님에게 처음 선택돼 있는 색입니다.
   견적서(견적 마법사)의 실 색은 assets/fc-colors.js 의 EMB 목록입니다 — 같이 맞춰 주세요.
*/
window.FCPO_EMB = [
  ['Black', 'rgb(17,17,17)'], ['Dark Grey', 'rgb(74,74,74)'], ['Grey', 'rgb(154,154,154)'],
  ['White', 'rgb(255,255,255)'], ['Off White', 'rgb(244,240,230)'], ['Beige', 'rgb(217,199,167)'],
  ['Putty', 'rgb(184,169,146)'], ['Brown', 'rgb(107,74,47)'], ['Dark Brown', 'rgb(63,42,26)'],
  ['Red', 'rgb(200,16,46)'], ['Burgundy', 'rgb(109,26,45)'], ['Orange', 'rgb(242,101,34)'],
  ['Gold', 'rgb(200,164,48)'], ['Lemon Yellow', 'rgb(244,224,77)'], ['Pink', 'rgb(240,78,152)'],
  ['Light Pink', 'rgb(244,184,200)'], ['Purple', 'rgb(107,63,160)'], ['Navy', 'rgb(30,42,68)'],
  ['Royal', 'rgb(27,63,174)'], ['Blue', 'rgb(47,111,191)'], ['Light Blue', 'rgb(157,198,232)'],
  ['Dark Green', 'rgb(18,73,43)'], ['Green', 'rgb(46,139,69)'], ['Olive', 'rgb(107,107,50)'],
  ['Sage', 'rgb(168,184,154)'], ['Mint', 'rgb(168,230,201)'], ['Neon Green', 'rgb(157,255,43)']
];

/* 3D 퍼프 색상 (모자 외 제품에서 사용) */
window.FCPO_PUFF = [
  ['Baby Pink', 'rgb(246,198,208)'], ['Beige', 'rgb(220,201,168)'], ['Brown', 'rgb(107,74,47)'],
  ['Blue', 'rgb(43,93,191)'], ['Dark Green', 'rgb(18,73,43)']
];